import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import $javelink_api from "../../api/services/javelink_api";
import {subscriptionsInfoList, WILD} from "../../pages/Authorized/SpecialAccess/Subscriptions/Subscriptions";
import axios from "axios";
import {TOKEN} from "../../storage/user";

export const fetchSubscriptions = createAsyncThunk(
    "subscription/fetchSubscriptions",
    async (_, {rejectWithValue}) => {
        try {
            // const {data} = await $subscriptions_service_api.get("subscription/client-info/");

            const {data} = await axios.get("https://api.wwa-ios.com/subscriptions/subscription/client-info/",  {
                headers: {
                    Authorization: `Bearer ${TOKEN}`
                }
            });

            // const {data} = await axios.get("https://stage-subscriptions.wwa-ios.com/subscriptions/subscription/client-info/", {
            //     headers: {
            //         Authorization: `Bearer ${TOKEN}`
            //     }
            // });

            return data
        } catch (error) {
            if (error.response) {
                const {data, status} = error.response;

                return rejectWithValue({data, status});
            } else {
                return rejectWithValue({message: error.message});
            }
        }
    },
);

export const activateSubscription = createAsyncThunk(
    "subscription/activateSubscription",
    async (dataObj) => {
        try {
            const {data, status} = await $javelink_api.post(
                "/account-subscriptions/activate/",
                dataObj
            );
            return {data, status}
        } catch (error) {
            const {data, status} = error.response;

            return {data, status};
        }
    },
);

export const disableAutoRenewSubscription = createAsyncThunk(
    "subscription/disableAutoRenewSubscription",
    async (id) => {
        try {
            const {data, status} = await $javelink_api.post(
                "/account-subscriptions/activate/disable-renew/",
                {
                    "subscription_id": id
                });
            return {data, status}
        } catch (error) {
            const {data, status} = error.response;

            return {data, status};
        }
    },
);

export const switchToPerInstallPayment = createAsyncThunk(
    "subscription/switchToPerInstallPayment",
    async ({isPaymentPerInstallationSubMode, subscription}) => {
        try {
            const keyWord = isPaymentPerInstallationSubMode ? 'No' : "Installs"

            const {data, status} = await $javelink_api.post(
                "/account-subscriptions/activate/change-payment-method/",
                {
                    // "method_to_change": "Installs"
                    "method_to_change": subscription || keyWord
                });
            return {data, status}
        } catch (error) {
            const {data, status} = error.response;

            return {data, status};
        }
    },
);

export const changePaymentMethod = createAsyncThunk(
    "subscription/changePaymentMethod",
    async (method) => {
        try {
            const {data, status} = await $javelink_api.post(
                "/account-subscriptions/activate/change-payment-method/",
                {
                    "method_to_change": method
                });
            return {data, status}
        } catch (error) {
            const {data, status} = error.response;

            return {data, status};
        }
    },
);

export const getSubscriptionPaymentMethodStatus = createAsyncThunk(
    "subscription/getSubscriptionPaymentMethodStatus",
    async () => {
        try {
            const {data, status} = await $javelink_api.get(
                "/account-subscriptions/activate/get-change-payment-method-status/",);
            return {data, status}
        } catch (error) {
            const {data, status} = error.response;

            return {data, status};
        }
    },
);

export const enableAutoRenewSubscription = createAsyncThunk(
    "subscription/enableAutoRenewSubscription",
    async (id) => {
        try {
            const {data, status} = await $javelink_api.post(
                "/account-subscriptions/activate/enable-renew/",
                {
                    "subscription_id": id
                });
            return {data, status}
        } catch (error) {
            const {data, status} = error.response;

            return {data, status};
        }
    },
);

export const renewSubscription = createAsyncThunk(
    "subscription/renewSubscription",
    async (id) => {
        try {
            const {data, status} = await $javelink_api.post(
                "/account-subscriptions/activate/renew-subscription/",
                {
                    "subscription_id": id,
                    'subscribe_months': 1
                });
            return {data, status}
        } catch (error) {
            const {data, status} = error.response;

            return {data, status};
        }
    },
);

const subscriptionSlice = createSlice({
    name: "subscription",
    initialState: {
        fetchSubscriptionsPending: false,
        subscriptionsList: [],
        testSubscription: {},
        cancelSubscriptionPending: false,
        wasSubscriptionActivated: false,
        freeDomainsCount: 0,
        isInitialInstallsLimits: false,
        activeSubscription: null,
        can_tm_add_count: null,
        isSubscriptionEndingPopupActive: false,
        isPaymentPerInstallationSubMode: false,
        paymentPerInstallationSubModePending: false,
        changePaymentMethodInfo: {},
        changePaymentMethodInfoPending: false,
        payment_method_to_change: null,
        payment_method_now: null,
        change_payment_method_status: false,
    },
    reducers: {
        updateSubscriptionsListAfterActivation: (state, {payload}) => {
            const {subscription_name, start_date, end_date, subscription_id} = payload;

            state.subscriptionsList = state.subscriptionsList.map(obj => ({
                ...obj,
                is_active: obj.name === subscription_name,
                active_by_time: obj.name === subscription_name,
                ...(obj.name === subscription_name && {
                    renew_subscription: subscription_name !== 'Test',
                    start_date,
                    end_date,
                    end_date_count: subscription_name !== 'Test' ? 30 : 14,
                    id: subscription_id,
                }),
            }));
        },
        updateSubscriptionsListAfterDisablingAutoRenew: (state, {payload}) => {
            state.subscriptionsList = state.subscriptionsList.map(obj =>
                obj.name === payload ? {...obj, renew_subscription: false} : obj
            );
        },
        updateSubscriptionsListAfterEnablingAutoRenew: (state, {payload}) => {
            state.subscriptionsList = state.subscriptionsList.map(obj =>
                obj.name === payload ? {...obj, renew_subscription: true} : obj
            );
        },
        setWasSubscriptionActivated: (state, {payload}) => {
            state.wasSubscriptionActivated = payload
        },
        setFreeDomainsCount: (state, {payload}) => {
            state.freeDomainsCount = payload
        },
        setIsInitialInstallsLimits: (state, {payload}) => {
            state.isInitialInstallsLimits = payload
        },
        setSubscriptionEndingPopupActive: (state, {payload}) => {
            state.isSubscriptionEndingPopupActive = payload
        },
        setCanTmAddCount: (state, {payload}) => {
            state.can_tm_add_count = payload
        },
        setSubscriptionPaymentMethodStatus: (state, {payload}) => {
            state.isPaymentPerInstallationSubMode = payload
        },
        setPaymentMethodToChange: (state, {payload}) => {
            state.payment_method_to_change = payload
        },
        setPaymentMethodNow: (state, {payload}) => {
            state.payment_method_now = payload
        },
        setChangePaymentMethodStatus: (state, {payload}) => {
            state.change_payment_method_status = payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getSubscriptionPaymentMethodStatus.pending, (state, {payload}) => {
                state.paymentPerInstallationSubModePending = true
                state.changePaymentMethodInfoPending = true
            })
            .addCase(getSubscriptionPaymentMethodStatus.fulfilled, (state, {payload}) => {
                state.isPaymentPerInstallationSubMode = payload?.data?.change_payment_method_status
                state.changePaymentMethodInfo = payload?.data
                state.payment_method_to_change = payload?.data?.payment_method_to_change
                state.payment_method_now = payload?.data?.payment_method_now
                state.change_payment_method_status = payload?.data?.change_payment_method_status
                state.changePaymentMethodInfoPending = false
                state.paymentPerInstallationSubModePending = false
            })
            .addCase(getSubscriptionPaymentMethodStatus.rejected, (state, {payload}) => {
                state.paymentPerInstallationSubModePending = false
                state.changePaymentMethodInfoPending = false
            })

            .addCase(fetchSubscriptions.pending, (state) => {
                state.fetchSubscriptionsPending = true;
                state.subscriptionsList = []
            })
            .addCase(fetchSubscriptions.fulfilled, (state, {payload = []}) => {


                state.wasSubscriptionActivated = payload?.some(item => item.start_date !== null);
                const activeSubscription = payload?.find(({
                                                              is_active,
                                                              active_by_time
                                                          }) => is_active === true && active_by_time === true)

                // const activeSubscription = payload?.find(({ is_active, active_by_time }) => is_active && active_by_time);

                state.activeSubscription = activeSubscription
                state.can_tm_add_count = activeSubscription?.user_limits?.can_tm_add_count || null

                const wildSubscription = payload.find(({is_active, packet_name, active_by_time}) =>
                    is_active && active_by_time && packet_name === WILD
                );

                state.freeDomainsCount = wildSubscription?.user_limits?.free_domains ?? 0;

                state.testSubscription = payload.find(
                    ({packet_name}) => packet_name === 'Test'
                );


                state.subscriptionsList = subscriptionsInfoList.map(item => {
                    const foundObj = payload.find(
                        ({packet_name}) => packet_name === item.name
                    );

                    if (!foundObj) {
                        return {...item};
                    }

                    const {
                        is_active,
                        active_by_time,
                        end_date,
                        start_date,
                        subscription_android_install_count,
                        subscription_ios_install_count,
                        subscription_pwa_install_count,
                        renew_subscription,
                        price,
                        subscription_id: id,
                        subscription_free_domains,
                        user_limits = {},
                        end_date_count
                    } = foundObj;

                    const {
                        pwa_install_count,
                        ios_install_count,
                        android_install_count,
                        free_domains
                    } = user_limits;

                    return {
                        ...item,
                        is_active,
                        active_by_time,
                        end_date,
                        start_date,
                        subscription_android_install_count,
                        subscription_ios_install_count,
                        subscription_pwa_install_count,
                        renew_subscription,
                        pwa_install_count,
                        ios_install_count,
                        android_install_count,
                        price,
                        id,
                        free_domains,
                        subscription_free_domains,
                        end_date_count
                    };
                });


                state.fetchSubscriptionsPending = false;
            })
            .addCase(fetchSubscriptions.rejected, (state) => {
                state.fetchSubscriptionsPending = false;
                state.subscriptionsList = []
            })
    },
});

export const {
    updateSubscriptionsListAfterActivation,
    updateSubscriptionsListAfterDisablingAutoRenew,
    updateSubscriptionsListAfterEnablingAutoRenew,
    setWasSubscriptionActivated,
    setFreeDomainsCount,
    setIsInitialInstallsLimits,
    setSubscriptionEndingPopupActive,
    setCanTmAddCount,
    setSubscriptionPaymentMethodStatus,
    setPaymentMethodToChange,
    setPaymentMethodNow,
    setChangePaymentMethodStatus
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;

export const subscriptionSelector = (state) => state.subscription;